export default __webpack_public_path__ + "static/media/vkpic1.cd07c10f.png";